export const clientBaseConfig = {
  url: '/api/checkout/orders',
  method: 'POST' as const,
};
